export default {
  'message.successSave': '{{entity}} נוצר בהצלחה',
  'message.successUpdate': '{{entity}} עודכן בהצלחה',
  'message.errorSave': 'אירעה שגיאה ביצירת {{entity}}',
  'message.errorUpdate': 'אירעה שגיאה בעדכון {{entity}}',
  'message.errorGet': 'נכשל בקבלת {{entity}}',
  'message.errorDownload': 'שגיאה בהורדת הקובץ',
  'message.successDelete': '{{entity}} נמחק בהצלחה',
  'message.errorDelete': 'נכשל במחיקת {{entity}}',
  'message.successSentVerificationEmail': 'אימייל אימות נשלח בהצלחה',
  'message.pendingEmailVerification': 'אימות אימייל בהמתנה',
  'message.errorSentVerificationEmail': 'שגיאה בשליחת אימייל אימות',
  'message.delete.explain': '{{entity}} סומן כנמחק',
  'message.delete.info': 'מחיקה זמינה רק במצב עריכה',
  'message.deactivate.info': 'השבת {{entity}}',
  'message.delete.warning': 'האם אתה בטוח שברצונך למחוק את ה־{{entity}} הזה?',
  'message.deactivate.warning':
    'האם אתה בטוח שברצונך למחוק את ה־{{entity}} הזה? תחילה הוא יסומן כמושבת.',
  'message.delete.confirm':
    'בעת אישור המחיקה, המערכת תבצע פעולה. ייתכן שה־{{entity}} יוסר ממסד הנתונים.',
  'message.inactive.confirm':
    'הישות תסומן כלא פעילה. היא לא תהיה גלויה או שמישה, אך לא תימחק מהמערכת.',
  'message.unassigned.warning':
    'האם אתה בטוח לחלוטין שברצונך להסיר את הקצאת ה־{{entity}} הזו?',
  'message.unassigned.confirm':
    'בעת אישור הסרת ההקצאה, המערכת תבצע פעולה. ייתכן שהקצאת ה־{{entity}} תוסר ממסד הנתונים.',
  'message.unload.title': 'שינויים שלא נשמרו',
  'message.unload.description':
    'יש לך שינויים שלא נשמרו. האם אתה בטוח שברצונך לעזוב את הדף?',
};
